import { useEffect } from "react"
import { Routers } from "../../../../../../../constant/Routers"
import { backToLogin } from "../../../../../../../utils/backToLogin"
import { UseTravelersBatchDeleteType } from "../../../../models/batchDelete"
import { TravelersBatchDeleteDataType } from "../../../../models/batchDelete/data"
import { useVariables } from "../useVariables"

const { SCR920 } = Routers

export const useTravelersBatchDelete =
  (): UseTravelersBatchDeleteType<TravelersBatchDeleteDataType> => {
    const {
      beforeUpload,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      bulkCheck,
      bulkDeleteData,
      bulkDelete,
      bulkRequestDelete,
      bulkFileDelete,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isNotAccessScreen,
      isOpen,
      isOpenDeleted,
      isRoleAdmin,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnDelete,
      onCancel,
      onCancelDeleted,
      onChange,
      onOpen,
      onOpenDeleted,
      perItem,
      push,
      setIsLoading,
    } = useVariables()

    const bulkDeleteDataConfirm = () => {
      bulkDeleteData()
      push(SCR920)
    }

    const onOk = () => {
      setIsLoading(true)
      if (isRoleAdmin) {
        bulkDelete()
      } else {
        bulkRequestDelete()
      }
    }

    const onOpenDeletedOrGoToHome = () => {
      if (dataTemps.length) {
        onOpenDeleted()
      } else {
        push(SCR920)
      }
    }

    useEffect(() => {
      // ユーザの画面アクセス許可チェックを処理する。
      if (isNotAccessScreen) {
        // 「SCR973_エラー情報の表示画面」に遷移する。
        const { pathname, state } = backToLogin()
        push({ pathname, state })
      } else bulkCheck()
    }, [])

    return {
      beforeUpload,
      bulkDeleteDataConfirm,
      bulkFileDelete,
      columnErrors,
      columns,
      countRecord,
      dataTemps,
      errorList,
      fileNameList,
      isDisabledSubmit,
      isLoading,
      isLoadingLayout,
      isOpen,
      isOpenDeleted,
      isResetTable,
      isVisibleBtnCancel,
      isVisibleBtnDelete,
      onCancel,
      onCancelDeleted,
      onChange,
      onOk,
      onOpen,
      onOpenDeletedOrGoToHome,
      perItem,
    }
  }
